module.exports = __webpack_public_path__ + "fonts/icomoon.b3415d6.woff";